import { supabase } from '../lib/supabase';
import { logError } from '../utils/logger';

export const sendEmailViaEdge = (type, booking, bookingId) => {
  supabase.functions.invoke('send-email', { body: { type, booking } })
    .then(({ error }) => {
      if (error) logError(supabase, 'email', `${type} failed: ${error.message}`, { booking_id: bookingId });
    });
};
